export const getCandidateStatusColor = (status: string): string => {
  const colors = {
    offered: 'bg-violet-100 text-violet-800',
    declined: 'bg-red-100 text-red-800',
    pending: 'bg-yellow-100 text-yellow-800',
    accepted: 'bg-green-100 text-green-800',
    joined: 'bg-slate-100 text-slate-800',
    failed: 'bg-red-100 text-red-800',
    passed: 'bg-green-100 text-green-800',
    hold: 'bg-orange-100 text-orange-800',
    selected: 'bg-amber-100 text-amber-800',
    assessment_sent: 'bg-blue-100 text-blue-800',
    assessment_in_progress: 'bg-indigo-100 text-indigo-800',
    assessment_started: 'bg-indigo-100 text-indigo-800',
    assessment_completed: 'bg-teal-100 text-teal-800',
    cv_submitted: 'bg-gray-100 text-gray-800',
  } as const;
  return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-800';
};
